import { createSelector } from 'reselect';

import {
  periodSelector,
  periodCurrencySelector,
  unpaidTuitionCostSelector,
  courseValidationSelector,
} from '../../../reducers/selectors';

const eligibilitySelector = status => status.builder.ui.eligibilityStatus === 'eligible';

const eligibleSelector = createSelector(
  eligibilitySelector,
  unpaidTuitionCostSelector,
  periodSelector,
  periodCurrencySelector,
  courseValidationSelector,

  (isEligible, unpaidTuitionCost, selectedPeriod, periodCurrency, validatedCourse) => {
    let status = 'eligible';
    const loanAmount = unpaidTuitionCost?.loanAmount;
    const loanCurrency = unpaidTuitionCost?.loanCurrency;
    const costOfTuition = selectedPeriod?.costOfTuition;
    const minimumLoanAmount = 10000;

    if (
      validatedCourse === false &&
      ((loanAmount && loanCurrency === periodCurrency && loanAmount < minimumLoanAmount) ||
        costOfTuition < minimumLoanAmount)
    ) {
      status = 'tuitionCostBelowMinimum';
    } else if (isEligible) {
      status = 'eligible';
    } else {
      status = 'ineligible';
    }
    return status;
  },
);

export default eligibleSelector;
